<template>
  <div
    id="sideMenu"
    class="side-menu"
    :hidden="!expanded"
  >
    <div class="side-menu__header">
      <TrybLogo width="48" height="38"/>
      <button
        type="button"
        aria-label="Close menu"
        @click="collapse"
      />
    </div>

    <nav
      class="side-menu_nav"
    >
      <ul role="menu">
        <li
          class="side-menu__listitem"
          v-for="(item, i) in menu"
          :key="i"
          role="none"
        >
          <router-link
            v-if="item.to"
            class="side-menu__item"
            role="menuitem"
            :class="{
              'side-menu__item_dashboard': item.dashboard,
              'side-menu__item_accent': item.accent,
            }"
            :to="item.to"
            :tabindex="tabindex"
          >
            {{ item.name }}
            <img
              v-if="item.image"
              :src="item.image"
              alt="Profile picture"
              aria-hidden="true"
              width="30"
              height="30"
            >
          </router-link>
          <a
            v-else-if="item.href"
            :href="item.href"
            :tabindex="tabindex"
            class="side-menu__item"
            role="menuitem"
            target="_blank"
            rel="noopener"
          >
            {{ item.name }}
          </a>
          <template v-else-if="item.menu">
            <button
              id="nestedMenuButton"
              type="button"
              role="menuitem"
              aria-haspopup="true"
              :aria-expanded="nestedExpanded ? 'true' : 'false'"
              aria-controls="nestedMenu"
              class="side-menu__item"
              @click="toggleNested"
            >
              {{ item.name }}
            </button>
            <ul
              id="nestedMenu"
              :hidden="!nestedExpanded"
              aria-labelledby="nestedMenuButton"
              role="menu"
              class="nested-menu"
            >
              <li
                v-for="(item, i) in item.menu"
                :key="i"
                role="none"
              >
                <router-link
                  class="nested-menu__item"
                  role="menuitem"
                  rel="noopener"
                  :tabindex="tabindex"
                  :to="item.to"
                >
                  {{ item.name }}
                </router-link>
              </li>
            </ul>
          </template>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
} from 'vuex';
import TrybLogo from '@/assets/icons/optimized/tryb_logo.svg?inline';


export default {
  name: 'SideMenu',
  components: { TrybLogo },
  data() {
    return {
      nestedExpanded: false,
    };
  },
  watch: {
    $route() {
      if (this.expanded) {
        this.collapse();
      }
    },
  },
  computed: {
    ...mapGetters({
      menu: 'menu/menu',
      expanded: 'menu/expanded',
    }),
    tabindex() {
      return this.expanded ? 0 : -1;
    },
  },
  methods: {
    ...mapMutations({
      collapse: 'menu/collapse',
    }),
    toggleNested() {
      this.nestedExpanded = !this.nestedExpanded;
    },
  },
};
</script>

<style
  scoped
  lang="scss"
>
.side-menu {
  &__header {
    height: 72px;
    margin-bottom: 1rem;
  }

  &_nav {
    padding: 0 1.5rem;
  }
}
</style>
